export interface ServiceCatalogItem {
	tariffs_default_id?: string;
	tariffs_custom_id?: string;
	article_id?: number;
	template_id?: number;
}

export type ServiceCatalogItemFilter = ServiceCatalogItem;

export interface ServiceCatalogFolder {
	id: string;
	name: string;
	folders: ServiceCatalogFolder[];
	items: ServiceCatalogItem[];
}

export interface ServiceCatalogTree {
	version: number;
	tree: ServiceCatalogFolder[];
}

export const EMPTY_CATALOG: ServiceCatalogTree = { version: 1, tree: [] };
